import type { ReactNode } from "react";
import { Clock, FileSignature, Layers, RefreshCw } from "lucide-react";

import type { BillingMode, IBillingSelection } from "../../interfaces";

export interface IBillingModeOption {
    value: BillingMode;
    title: string;
    description: string;
    icon: ReactNode;
}

export const BILLING_MODES: IBillingModeOption[] = [
    {
        value: "TRIAL",
        title: "Trial",
        description: "Full access for a fixed evaluation period, then billing must be set.",
        icon: <Clock size={18} />,
    },
    {
        value: "SUBSCRIPTION",
        title: "Subscription",
        description: "Recurring charge per seat, billed monthly or annually.",
        icon: <RefreshCw size={18} />,
    },
    {
        value: "PER_PROJECT",
        title: "Per Project",
        description: "Charged for each project the organization creates.",
        icon: <Layers size={18} />,
    },
    {
        value: "CUSTOM",
        title: "Custom",
        description: "Negotiated contract invoiced manually outside the platform.",
        icon: <FileSignature size={18} />,
    },
];

export const TRIAL_LENGTH_OPTIONS = [
    { value: "14", label: "14 days" },
    { value: "30", label: "30 days" },
    { value: "60", label: "60 days" },
    { value: "90", label: "90 days" },
];

export const DEFAULT_BILLING_SELECTION: IBillingSelection = {
    Mode: "TRIAL",
    Cycle: "MONTHLY",
    TrialDays: "30",
    Seats: "5",
    RatePerSeat: "",
    RatePerProject: "",
    ContractReference: "",
    BillingEmail: "",
};
